import React from 'react';

const STORY_CONTENT = `
I started The Daily Art because I wanted to see what happens when different people interpret the same idea—using the same simple tools. No shortcuts, no advantages—just a level playing field. I love seeing what artists come up with and comparing and contrasting the different takes.

But the deeper reason is this: I think the world needs good art. More than anybody realizes.

There are more tools than ever to create with, but for a lot of people—especially beginners—that's part of the problem. It can be overwhelming. We spend so much time learning how to create that we forget to ask a more important question: what should we create?

For me, art starts there.
What do I wish existed in the world?
What feels true, meaningful, or worth bringing into existence?
What is good—and how do I show it?
The Daily Art is my way of exploring those questions, one simple prompt at a time.
`;

function Story() {
  const paragraphs = STORY_CONTENT
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <section className="story" id="story">
      <h2 className="story-heading">My story</h2>
      {paragraphs.map((p, i) => {
        const lines = p.split('\n');
        return (
          <p key={i} className="story-paragraph">
            {lines.map((line, j) => (
              <React.Fragment key={j}>
                {line}
                {j < lines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        );
      })}
    </section>
  );
}

export default Story;
